import { z } from "zod";

export const FormDataSchema = z.object({
  mapPlotRequestId: z.number().optional(),
  name: z
    .string()
    .min(1, "識別名は必須です")
    .max(255, "識別名は255文字以内で入力してください"),
  tags: z.array(z.string()).default([]),
  additionalFields: z.record(z.string()).optional(),
});

export type FormData = z.infer<typeof FormDataSchema>;
